import React from "react";
import './video_slider.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import TemplatePagePlaceholder from "../../containers/template_page/template_page_placeholder/template_page_placeholder";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class C65VideoSliderCarousel extends TemplateComponent {

    constructor(props) {
        super(props);
        this.vidRef = React.createRef();
        this.state = {
            slideIndex: 1,
            isHidden: false,
            playing: false
        }
    }

    componentRender(data) {
        let videoPars = {
            controls: this.state.playing
        };
        videoPars["poster"] = data.carousel_items.image;

        const settings = {
            dots: false,
            infinite: true,
            speed: 200,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            cssEase: "ease-in",
            afterChange: (index) => this.setState(state => ({slideIndex: index + 1})),
            responsive: [
                {
                    breakpoint: 415,
                    settings: {
                        centerMode: true,
                        centerPadding: "30px",
                    }
                },
                {
                    breakpoint: 380,
                    settings: {
                        centerMode: true,
                        centerPadding: "12px",
                        slidesToShow: 1
                    }
                }
            ]
        };

        return (
            <div className='c65-video-slider-carousel'>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 mx-auto">
                            <Slider ref={slider => (this.slider = slider)} {...settings}>
                                {data.carousel_items.map((el, index) => (
                                    <div className={'video-slide-wrap'} key={index}>
                                        <TemplatePagePlaceholder image={el.image} video={el.video_url}/>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
                <div className="slider-fraction">
                    <span>{this.state.slideIndex}</span><span>/{data.carousel_items.length}</span>
                </div>
                <div className="slide-container">
                    <input
                        className="progressive-slider"
                        onChange={event => {this.slider.slickGoTo(event.target.value)}}
                        value={this.state.slideIndex}
                        type="range"
                        min="1"
                        max={data.carousel_items.length}
                    />
                </div>
            </div>
        )
    }
}

export default C65VideoSliderCarousel;
